import { exposeFunction } from "@/utils/pages";

import cookie_law from './cookie-law';

export default function gaOptout() {
    cookie_law();
}
exposeFunction("gaOptout", gaOptout);

